export const sbImage = (
  url,
  { w, h, fit = "cover", q = 80, fmt = "webp" } = {}
) => {
  if (!url || typeof url !== "string") return url;

  // Don’t transform SVGs or already-transformed URLs
  if (url.endsWith(".svg") || url.includes("/m/")) return url;

  // Only transform Storyblok image service URLs
  const isStoryblokHosted =
    url.includes("a.storyblok.com") || url.includes("img2.storyblok.com");

  if (!isStoryblokHosted) return url;

  const base = url.split("?")[0].split("#")[0];

  const size = `${w || ""}x${h || ""}`.replace(/x$/, "");
  const fitFilter = fit ? `:fill(${fit})` : "";
  const filters = `filters:format(${fmt}):quality(${q})`;

  return `${base}/m/${size}${fitFilter}/${filters}`;
};
